<ng-container *ngIf="integrations$ | async"></ng-container>
<scaffold-dialog
  *ngIf="integration"
  showCloseButton="true"
  (close)="close()"
  [size]="'wide'"
  [fullHeight]="true"
>
  <div scaffoldDialogBody>
    <div class="integration-status-modal" scaffoldDialogBody>
      <div class="integration-status-modal-header-edit-button">
        <p-button [variant]="'text'" severity="link" class="integration-status-item-pause-button"
        *ngIf="roleData?.manage_integrations && integration.integration_type !== 'live_event' && integration.integration_type !== 'dwh'" (click)="handleRefreshClick()">
        <i class="fa-solid fa-refresh"></i> {{'refresh' | translation}}
        </p-button>
        <p-button [variant]="'text'" severity="link" class="integration-status-item-pause-button"
        *ngIf="roleData?.manage_integrations && integration.integration_type !== 'live_event' && integration.integration_type !== 'dwh'"
        (click)="handleEditClick(integration)">
          <i class="fa-solid fa-pencil"></i> {{'edit' | translation}}
        </p-button>
      </div>
      <div class="integration-status-modal-header">
        <div class="integration-status-modal-header-title">
          <div class="integration-status-item-icon">
            <img [src]="logo | safe" (error)="logo = getPlaceholderLogo()" />
          </div>
          <div class="integration-status-modal-header-title-name">
            <h2>{{ integration?.json_data?.friendly_name }}</h2>
            <div class="integration-status-modal-header-state">
              {{ integration.generatedState | translation }}
            </div>
          </div>
        </div>
      </div>
      <div class="integration-status-details">
        <div class="integration-status-details-item">
          <label>Type</label>
          <p>
            {{ integration?.integration_type | transformText : "uppercase" }} -
            {{integration?.json_data?.[integration?.integration_type + '_type'] | transformText : 'capitalize'}}
          </p>
        </div>
        <div class="integration-status-details-item">
          <label>Status</label>
          <p>
            {{
              integration?.generatedStatus
                | translation
                | transformText : "capitalize"
            }}
          </p>
        </div>
        <div class="integration-status-details-item">
          <label>Last Updated</label>
          <p>{{ integration?.updated_at | date : "MM/dd/yyyy hh:mm a" }}</p>
        </div>
      </div>
      <div *ngIf="!['canvas','brightspace'].includes(integration?.json_data?.lms_type)">
        <div class="configurable-table-holder">
          <table class="contrast-table">
            <thead>
              <tr>
                <th style="width: 50px">Status</th>
                <th>Check</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let status of validateStatus()">
                <td style="width: 50px; text-align: center">
                  <span>
                    <i
                      [title]="status?.message || 'Unknown'"
                      class="fa-solid"
                      [ngClass]="{
                    'integration-status-modal-success-icon': status?.status === 'ok',
                    'fa-circle-check':status?.status === 'ok',
        
                    'integration-status-modal-error-icon':status?.status === 'error',
                    'fa-circle-x':status?.status === 'error',
            
                    'integration-status-modal-process-icon':status?.status === 'processing' || !status?.status,
                    'fa-loader':status?.status === 'processing' || !status?.status,
                    'fa-spin':status?.status === 'processing' || !status?.status,
        
              }"
                    ></i>
                  </span>
                </td>
                <td>{{ status.title }}</td>
                <td [innerHTML]="status?.message | safeHtml"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="['canvas','brightspace'].includes(integration?.json_data?.lms_type)">
      <p-tabs value="validation">
        <p-tablist>
          <p-tab value="validation">Validation</p-tab>
          <p-tab value="permissions">Permissions</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="validation">
            <div class="configurable-table-holder">
              <table class="contrast-table">
              <thead>
                <tr>
                  <th style="width: 50px;">Status</th>
                  <th>Check</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let status of validateStatus()">
                  <td style="width: 50px;text-align: center;">
                    <span>
                      <i [title]="status?.message || 'Unknown'" class="fa-solid"
                        [ngClass]="{
                      'integration-status-modal-success-icon': status?.status === 'ok',
                      'fa-circle-check':status?.status === 'ok',
          
                      'integration-status-modal-error-icon':status?.status === 'error',
                      'fa-circle-x':status?.status === 'error',
              
                      'integration-status-modal-process-icon':status?.status === 'processing' || !status?.status,
                      'fa-loader':status?.status === 'processing' || !status?.status,
                      'fa-spin':status?.status === 'processing' || !status?.status,
          
                }"></i>
                    </span>
                  </td>
                  <td>{{status.title}}</td>
                  <td [innerHTML]="status?.message|safeHtml">
                  </td>
  
                </tr>
              </tbody>
            </table>
          </div>
        </p-tabpanel>
        <p-tabpanel value="permissions">
            <app-integration-permissions [data]="{integration}"></app-integration-permissions>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
      </div>
    </div>
  </div>
</scaffold-dialog>
